import { render, staticRenderFns } from "./CouponM.vue?vue&type=template&id=70cac4c0"
import script from "./CouponM.vue?vue&type=script&lang=js"
export * from "./CouponM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports